export default "__VITE_ASSET__48200053__"